const Tab = ({ children }) => {
  return <div className="tab">{children}</div>;
};

export default Tab;
